import { MprcButtonDropdownChecked } from "components/MprcButtonDropdownChecked";
import { KnowledgeSearchRestriction } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";

interface IProps {
    selectedOption: any;
    onChange: (selected: any) => void;
}

export const ChooseKnowledgeRestrictionComponent = ({ selectedOption, onChange }: IProps) => {
    const { t } = useTranslation("shared");
    return (
        <MprcButtonDropdownChecked
            title={t("GlobalSearch.Filters.Knowledge.RestrictionOption")}
            selected={selectedOption}
            onChange={(selected) => onChange(selected)}
            items={
                [
                    { text: t("GlobalSearch.Filters.Knowledge.Restriction.All"), value: null },
                    { text: t("GlobalSearch.Filters.Knowledge.Restriction.TitleAndContent"), value: KnowledgeSearchRestriction.TitleAndContent },
                    { text: t("GlobalSearch.Filters.Knowledge.Restriction.Title"), value: KnowledgeSearchRestriction.Title },
                ]
            }
        />
    );
};
